import { agroApi } from '../api'
import { EntDepMechReportPayload } from '../../../models/departmentMechReport'
import { BlobResponse } from '../../../models/report'

export const kurultaiReportApi = agroApi.injectEndpoints({
	endpoints: builder => ({
		getReportByKurultaiRegister: builder.mutation<BlobResponse, EntDepMechReportPayload>({
			query: body => ({
				url: "/kurultai-register/report",
				method: "POST",
				body,
				responseHandler: (response) => response.blob(),
			}),
		}),
	}),
	overrideExisting: false,
})

export const { useGetReportByKurultaiRegisterMutation } = kurultaiReportApi
